import React from 'react';

export const useUrineTrendPrintStyles = () => {
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 4mm;
        }
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .urine-trend-print-root {
          position: static !important;
          left: auto !important;
          top: auto !important;
          width: 100% !important;
          opacity: 1 !important;
          visibility: visible !important;
          z-index: auto !important;
          overflow: visible !important;
        }
        .urine-trend-print-content {
          overflow: visible !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
};
